module.exports = __webpack_public_path__ + "img/供餐-3.e1ae6e8b.jpg";